import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router';
import { useState } from 'react';
import '../../styles/scss/Header.scss';

export default function Header() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const getBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Admin', path: '/admin/dashboard' }];
    
    const labelMap: Record<string, string> = {
      dashboard: 'Dashboard',
      categories: 'Categories',
      'sub-categories': 'Sub Categories',
      'master-services': 'Master Services',
      natures: 'Natures',
      ledgers: 'Ledgers',
      'product-labels': 'Product Labels',
      'product-highlights': 'Product Highlights',
      'care-instructions': 'Care Instructions',
      products: 'Products',
      create: 'Create',
    };

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      if (index > 0) {
        currentPath += '/' + segment;
        const label = labelMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
        breadcrumbs.push({ 
          label, 
          path: pathSegments.length === index + 1 ? '' : `/admin${currentPath}`
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <Box component="header" className="top-header">
      <Box className="header-left">
        <nav className="breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <Box key={index} component="span" sx={{ display: 'flex', alignItems: 'center' }}>
              {index > 0 && <span className="separator">/</span>}
              {crumb.path ? (
                <Link to={crumb.path}>{crumb.label}</Link>
              ) : (
                <span className="current">{crumb.label}</span>
              )}
            </Box>
          ))}
        </nav>
      </Box>
      
      <Box className="header-right">
        <button className="language-selector">
          <span className="material-symbols-outlined">language</span>
          EN
        </button>
        
        <button className="notification-btn">
          <span className="material-symbols-outlined">notifications</span>
          <span className="notification-dot"></span>
        </button>
        
        <Box className="user-profile">
          <Box className="user-info">
            <p>Admin User</p>
            <p>Administrator</p>
          </Box>
          <Box className="user-avatar">
            <img 
              src="https://api.dicebear.com/7.x/initials/svg?seed=AU&backgroundColor=000b60&textColor=ffffff" 
              alt="User Avatar" 
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
